import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import ConfirmModal from "../Confirm";
import { deleteUser } from "../../../../store/BackOffice/actions";
import { openModal } from "../../../../store/Modals/actions";
import {
  MODAL_CONFIRM,
  MODAL_CANCEL_USER,
} from "../../../../store/Modals/constants";
import { CONFIRM_CANCEL_USER_MESSAGE } from "../Confirm/constants";

const CancelUser = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(openModal(MODAL_CONFIRM));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ConfirmModal
      modal={MODAL_CANCEL_USER}
      action={() => dispatch(deleteUser(false))}
      message={CONFIRM_CANCEL_USER_MESSAGE}
    />
  );
};

export default CancelUser;
